import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './servicing-seatmap.actions';
import { ServicingSeatmapState } from './servicing-seatmap.state';

/**
 * servicingSeatmap initial state
 */
export const servicingSeatmapInitialState: ServicingSeatmapState = {
  model: null,
};

/**
 * List of basic actions for ServicingSeatmap Store
 */
export const servicingSeatmapReducerFeatures: ReducerTypes<ServicingSeatmapState, ActionCreator[]>[] = [
  on(actions.setServicingSeatmap, (_state, payload) => ({ ...payload })),

  on(actions.updateServicingSeatmap, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetServicingSeatmap, () => servicingSeatmapInitialState),
];

/**
 * ServicingSeatmap Store reducer
 */
export const servicingSeatmapReducer = createReducer(servicingSeatmapInitialState, ...servicingSeatmapReducerFeatures);
